export enum FlightStatus {
    // TODO: remove new record flight status, it doesn't make sense, flight without position is valid
    NewRecord = -1, // Newly added record, neither position nor flight parameters have been set
    NotValid = 0, // Not a valid plane record
    Departed = 1, // Plane departed but no position reported
    Active = 2, // One or more position reports received
    Arrived = 3, // Arrival message received
    Agedout = 4, // No message received for 8 minutes
    Hold = 5,
    Planned = 6,
    Scheduled = 7,
    Parked = 8
}

export enum ObjectClass {
    Unknown = 0, // default null value
    Air = 1, // aircraft
    Road = 2, // ground vehicles
    Rail = 3, // reserved for future use
    Sea = 4, // reserved for future use
    Fixed = 5 // reserved for future use
}

export enum DrawSymbol {
    Unknown = 0, // default or null or unknown value
    Circle = 1, // via config option
    Triangle = 2, // via config option
    HeavyJet4 = 3, // 4 engine heavy jet - ala ACTypes B74*, A34*, or A38*
    HeavyJet = 4, // heavy jet ala B76*, B77*, B78*, A33*, A35*
    LargeJet = 5, // large commercial plane
    SmallJet = 6, // small jet
    TurboProp = 7, // turbo propeller
    PistonProp = 8, // piston propeller
    Helicopter = 9,
    GroundVehicle = 10,
    DroneRotor = 11, // drone with blades (like helicopter)
    DroneFixed = 12, // drone fixed wing (like airplane)
    Train = 13, // reserved for future
    Ship = 14, // reserved for future
    Person = 15 // reserved for future
}

export enum Heavy {
    Unknown = 0,
    Yes = 1,
    No = 2
}

export enum Tcas {
    Unknown = 0,
    Yes = 1,
    No = 2
}

export enum AltitudeUnit {
    Feet = 0,
    Meter = 1
}

export enum IrregularOperations {
    None = 0,
    Diversion = 1,
    ExtraStop = 2,
    OverFly = 3,
    ReturnToField = 4,
    ReturnToGate = 5
}

export enum DelayReason {
    Unknown = 0,
    GDP = 1, // general delay program
    ADP = 2,
    GS = 3, // ground stop
    ABRG = 4,
    BLKT = 5,
    COMP = 6,
    DAS = 7,
    ECR = 8,
    GAAP = 9,
    RCTL = 10,
    SBRG = 11,
    SCS = 12,
    SUB = 13,
    UPD = 14,
    ADPT = 15
}

export enum PlannedSpeedType {
    trueAir = 0,
    mach = 1,
    classified = 2,
    ground = 3
}

export enum AirportSelection {
    None = 0,
    ArrRate = 1,
    ArrRWays,
    arrDel,
    closureAltPS,
    closureAltAct,
    closuredm,
    closurestart,
    closureend,
    closureDestPS,
    closureDestAct,
    depDel,
    DepRate,
    Deicing,
    DepRWays,
    metarFc,
    metarVis,
    metarCeil,
    metarWs,
    metarWg,
    metarTmp,
    metarWd,
    metarDew,
    metarAltimeter,
    metartime,
    taftime,
    taf,
    rvrWc,
    gndStp,
    gndDelay,
    clFaa,
    iataId,
    icaoId,
    /**
     * @deprecated this looks to be unused
     */
    monStat,
    diversioncapacityairlinenarrow,
    diversioncapacityairlinewide,
    diversioncapacitynetworknarrow,
    diversioncapacitynetworkwide,
    diversioncapacityothernarrow,
    diversioncapacityotherwide,
    diversiondivertairlinenarrow,
    diversiondivertairlinewide,
    diversiondivertnetworknarrow,
    diversiondivertnetworkwide,
    diversiondivertothernarrow,
    diversiondivertotherwide,
    diversionavailableairlinenarrow,
    diversionavailableairlinewide,
    diversionavailablenetworknarrow,
    diversionavailablenetworkwide,
    diversionavailableothernarrow,
    diversionavailableotherwide,
    diversioncomments,
    diversioncapacityairlinetotal,
    diversioncapacitynetworktotal,
    diversioncapacityothertotal,
    diversiondivertairlinetotal,
    diversiondivertnetworktotal,
    diversiondivertothertotal,
    diversionavailableairlinetotal,
    diversionavailablenetworktotal,
    diversionavailableothertotal,
    MonStatApt,
    MonStatOrg,
    MonStatDst,
    MonStatAlt,
    fltholdinginto,
    Notes
}

export enum AirportTooltipInfoField {
    AptType = 'AptType',
    MagVar = 'MagVar',
    Elevation = 'Elevation',
    Use = 'Use',
    ControlTower = 'ControlTower',
    IcaoArff = 'IcaoArff',
    FaaArff = 'FaaArff'
}

export enum FeFrameContentType {
    Unknown = 0,
    Binary = 1,
    Json = 2
}

export enum FeFrameCompressionType {
    None = 0,
    Zstd = 1,
    Zlib = 2
}

export enum MyFleetMatchType {
    notApplicable,
    arrival,
    departure
}

export enum FlightFobVolumeDisplayUnit {
    Gallon,
    Liter
}

export enum FlightFobWeightDisplayUnit {
    Pound,
    Kilogram
}

export enum OnMapControlsDisplayEnum {
    Show,
    OnlyWhenActive,
    Hide
}

export enum LatLongDisplayFormatEnum {
    SignedDecimalDegrees = 0,
    UnsignedDecimalDegrees = 1,
    DegreesAndDecimalMinutes = 2,
    DegreesMinutesDecimalSeconds = 3
}

export enum LatLongDisplayFormatLogFileEnum {
    Default = 0,
    SignedDecimalDegrees = 1,
    UnsignedDecimalDegrees = 2,
    DegreesAndDecimalMinutes = 3,
    DegreesMinutesAndDecimalSeconds = 4
}

export enum DistanceUnitsEnum {
    NauticalMiles = 0,
    StatuteMiles = 1,
    Kilometers = 2
}

export enum IntegrationStatus {
    Ok = 0, // FPM_LOGINSTAT_OK
    Duplicate = 1, // FPM_LOGINSTAT_DUPLICATE
    NoRights = 2, // FPM_LOGINSTAT_NORIGHTS
    None = 3, // FPM_LOGINSTAT_NONE
    Unknown = 4 // FPM_LOGINSTAT_UNKNOWN
}

export enum TimeDisplayZone {
    Utc = 0,
    Local = 1
}

export enum TimeDisplayFormat {
    H24,
    H12
}

export enum DateTimeFormatEnum {
    MonthDayYear = 0,
    YearMonthDay = 1,
    DayMonthYear = 2
}

export enum DateDelimitersEnum {
    Slash = 0,
    Dot = 1,
    Dash = 2
}

export enum FeLoginResult {
    Valid = 0,
    Idnotfound = 1, // ID not found under ANY client type in the database
    Invalidpwd = 2, // All but WSI
    Logintimeout = 3,
    Badversion = 4, // This build # not allowed on this server
    Expired = 5,
    Nosession = 6,
    Invalidip = 7, // changed to 7 for 4f, from 5
    Disabled = 8, // PERS only as of 3.00
    Incorrectclient = 9, // UserID is set for different edition than what user is trying to connect with, OR clienttype loggin in with does not match valid client types defined
    Noactiveplanes = 10,
    Badcreditcard = 11, // Account disabled because of bad credit card info
    Corruptmsg = 12, // Anything corrupt in incoming message
    Servertype = 13, // Not authorized for this server type (Production, Staging, Test)
    Agedout = 14, // Client heartbeat not received within timeout (currently used in DB stored procedure)
    Rollover = 50, // Telling client to connect to another server
    Sessiondump = 51, // Mid-session dump for session log
    Initnotcomplete = 52, // Indicates that a Personal customer did not complete init
    NotFilledIn = 99
}

export type UserRightEntry = { idx: number; mask: number };

// idx = DWX = X - 1
export const Rights = {
    MonitorUser: { idx: 5, mask: 0x00000080 },
    CompanyViewEdit: { idx: 6, mask: 0x00000040 },
    CompanyThresholdsEdit: { idx: 6, mask: 0x00000040 },
    CompanyFilterGroupsEdit: { idx: 6, mask: 0x00000040 },
    CompanyNotesEdit: { idx: 6, mask: 0x00000040 },
    CustomerAdmin: { idx: 3, mask: 0x01000000 },
    RouteAi: { idx: 6, mask: 0x00000080 },
    ClientDebug: { idx: 6, mask: 0x00000400 },
    ShowWatermark: { idx: 2, mask: 0x02000000 },
    AdvancedWeather: { idx: 4, mask: 0x40000000 },
    ImpactsMonitoring: { idx: 3, mask: 0x00400000 },
    WaypointMonitoring: { idx: 5, mask: 0x20000000 },
    IgnoreSystemHubPopup: { idx: 5, mask: 0x04000000 },
    AcarsUpdateNow: { idx: 5, mask: 0x00000400 }, //Allows user to request an immediate ACARS position update
    AcarsUpdateInterval: { idx: 5, mask: 0x00000800 }, //Allows user to set the flight's ACARS position update request interval
    ManualFlightDataEntry: { idx: 3, mask: 0x00100000 },
    RouteAlerts: { idx: 3, mask: 0x00080000 },
    FPMIntegration: { idx: 3, mask: 0x10000000 },
    DesktopIntegration: { idx: 1, mask: 0x00000010 },
    DtnAviation: { idx: 2, mask: 0x00002000 },
    AlertEmailEx: { idx: 6, mask: 0x00000800 },
    WebSnapshot: { idx: 6, mask: 0x00001000 },
    Dashboard: { idx: 6, mask: 0x00002000 },
    AI: { idx: 6, mask: 0x00008000 }
} as const;

export enum AppState {
    Starting = 0,
    Intro = 1,
    Connecting = 2,
    Logging = 3,
    Running = 4,
    Reconnecting = 5,
    LoginFailed = 6
}

// Do not change the order of this enum
export enum ApiEnvironments {
    dev,
    cert,
    prod,
    prodAlt,
    dev2,
    local
}
export enum UpdateSource {
    TZ3,
    Sfc1,
    Sfc2,
    Init2d,
    Init1,
    NewPlane,
    NewPlaneEx,
    PropA2,
    PropNA2,
    None
}

export enum VisibilityRelation {
    null,
    greaterThan,
    lessThan
}

export enum AirportFlightCategory {
    unknown = 0,
    VFR = 1,
    MVFR = 2,
    IFR = 3,
    LIFR = 4,
    BCAT1 = 5
}

export enum AirportClosureType {
    closure = 'C'.charCodeAt(0),
    groundStop = 'P'.charCodeAt(0),
    groundDelay = 'G'.charCodeAt(0),
    arrival = 'A'.charCodeAt(0),
    departure = 'D'.charCodeAt(0)
}

export enum AirportDelayTrend {
    increasing = 'I'.charCodeAt(0),
    decreasing = 'D'.charCodeAt(0)
}

export enum AirportHoldFixType {
    fixName = 1,
    radialDistance = 2,
    latLng = 3,
    locationId = 4,
    undefined = 5 | 6
}

export enum AirportHoldSource {
    fe = 0,
    faa = 1
}

export enum AirportHoldExitType {
    actual = 0,
    estimate = 1
}

export enum DiversionPlaneStatus {
    enRoute = 0,
    ground = 1
}

export enum DiversionPlaneSubStatus {
    none = 0,
    on = 1,
    in = 2,
    unused = 3
}

export enum DiversionPlaneBodyType {
    heavyWide = 0,
    narrowOther = 1
}

export enum DiversionPlaneGroup {
    unknown = 0,
    airline = 1,
    network = 2,
    other = 3
}

export enum GeneralEventSubjectType {
    airport = 1,
    aircraft = 2,
    feInternal = 3
}

export enum GeneralEventState {
    reset = 0,
    set = 1,
    setReset = 2
}

export enum GeneralEventCode {
    dmDataReload = 9500,
    systemHubUpdate = 9505,
    clientConnectionTest = 9506
}

export enum FlightListFilterMode {
    all = 0,
    myFleet = 1,
    view = 2
}

export enum MapLanguageMode {
    english = 0,
    device = 1,
    localLatin = 2,
    localNative = 3,
    bilingual = 4 // English + local(latin)
}

export enum AlertSoundType {
    sound1,
    sound2,
    sound3
}

export enum FPMSyncType {
    global = 0,
    userSpecific = 1
}
export enum FPMMessageType {
    FPMUserRq = 1, // Not used? (FPM login is part of the login request)
    FMPUserRs = 2,
    GoToFlight = 3,
    GoToFlightRs = 4,
    RequestRoute = 5,
    StoreArea = 6,
    DeleteArea = 7,
    ModifyArea = 8, //not used?
    RouteResponse = 9,
    CalculateRouteRq = 10,
    CalculateRouteNotif = 11,
    CalculateRouteRs = 12,
    PlannedRouteResponse = 13,
    VerifyRouteRequest = 14,
    VerifyRouteResponse = 15,
    TextInfo = 16,
    StoreAreaRs = 17 // not used?
}
// #define CSINTFM_FPMUSERRQ       1  // FPM user request (to FPM, FEServer generates)
// #define CSINTFM_FPMUSERRS       2  // FPM user response (send permissions from FPM back to FEClient)
// #define CSINTFM_GOTOFLIGHT      3  // FPM issued GotoFlightRQ
// #define CSINTFM_GOTOFLIGHTRS    4  // this is only generated by FEServer to ack an inbound GotoFlightRQ
// #define CSINTFM_REQUESTROUTE    5  // generated by FEClient and passed to FPM
// #define CSINTFM_STOREAREA       6  // generated by FEClient and passed to FPM. Sends avoidance area
// #define CSINTFM_DELETEAREA      7  // generated by FEClient and passed to FPM. deletes avoidance area
// #define CSINTFM_MODIDYAREA      8  // generated by FPM and passed to FEClient. modifies avoidance area
// #define CSINTFM_ROUTERESPONSE   9  // generated by FPM and passed to FEClient.
// #define CSINTFM_CALCROUTERQ    10  // generated by FEClient and passed to FPM
// #define CSINTFM_CALCROUTENOTIF 11  // generated by FPM and passed to FEClient (ack that request was received
// #define CSINTFM_CALCROUTERS    12  // generated by FPM and passed to FEClient (planned data)
// #define CSINTFM_PLANNEDROUTE   13  // generated by FEServer (via FPM) and passed to FEClient (flight plan data)
// #define CSINTFM_VERYIFYROUTERQ 14  // generated by FEClient and passed to FPM
// #define CSINTFM_VERYIFYROUTERS 15  // generated by FPM and passed to FEClient
// #define CSINTFM_TEXTINFO       16  // generated by FPM via CalculateRouteRS or RequestRouteRS
// #define CSINTFM_STOREAREARS    17  // generated by FPM as response to CSINTFM_STOREAREA

export enum WeatherLegendDateTimeDisplay {
    none = 0,
    timeOnly = 1,
    timeDay = 2,
    timeDate = 3
}

export enum AlternateDestinationRecordType {
    unused,
    arrival,
    etops,
    takeOff,
    driftDown
}

export enum LoginResultCode {
    ok,
    notFound,
    noAccess,
    expired,
    disabled,
    tooManySessions,
    serviceUnavailable
}

export enum RefreshTokenResultCode {
    invalidToken,
    tokenNotFound,
    tokenExpired,
    userNotFound,
    noAccess,
    accountExpired,
    accountDisabled,
    tooManySessions,
    serviceUnavailable
}

export enum LoginIdentityProviderResultCode {
    ok,
    noMatch,
    noAccessFlightExplorer,
    noAccessProvider,
    expired,
    disabled,
    tooManySessions,
    unknownError,
    serviceUnavailable
}

/** @deprecated */
export enum ServiceLoginResponse {
    ok = 0,
    invalidCredentials = 1,
    versionNotSupported = 2,
    unauthorizedForMobileAccess3 = 3,
    unauthorizedForMobileAccess4 = 4,
    accountExpired = 5,
    connectionLimitExceeded = 6,
    otherError = 7,

    // Client side event
    serviceUnavailable = 9999
}

export enum GetLastKnowLocationTypeEnum {
    acid = 1,
    tail = 2,
    icao = 3
}

export enum FeedbackType {
    none,
    generalComment,
    featureRequest,
    technicalQuestion,
    troubleReport
}

export enum UpdateSettingType {
    update,
    delete
}

export enum MapGotoTarget {
    active = 0,
    all = 1,
    map0 = 2,
    map1 = 3,
    map2 = 4,
    map3 = 5
}

export enum StarmapType {
    basic = 0,
    enhanced = 1
}
